// import cartUI from 'components/cart/cartUI'
import memberUI from "@page/common/js/memberUI";
import Accordion from "@global/components/global/accordion";
import ToggleMenu from "@page/common/js/global/ToggleMenu";

var NowMyEquipment = nowEnv.NowMyEquipment;

export default {
	memberPage: function () {
		if (NowMyEquipment) {
			ToggleMenu(".member-menu > h3");
		}

		Accordion(".order-accordion", { children: "div" });
		memberUI.printCarrierNote();
		memberUI.editMemberBirth();
		memberUI.toggleBankManual();

		$(window).trigger("checkImg", {
			type: "hidden",
			target: ".member-content",
		});
	},

	corpPage: function () {
		if (NowMyEquipment) {
			ToggleMenu(".corp-menu > h2");
		}

		$(window).trigger("checkImg", {
			type: "hidden",
			target: ".corp-content",
		});
	},
};
